import { FC } from 'react';
import styled from 'styled-components';
import { CombinerTypeSelect } from '../../components/combiner-type-select';
import { FilterBoxWrapper, Row } from '../../components/common';
import { GroupedFilter } from '../../grouped-filter';
import { BaseGroupedFilterComponentProps } from '../../types';

export interface Props extends BaseGroupedFilterComponentProps {
  addButtonText?: string;
  hideMatchTypeText?: boolean;
  showFilterType?: boolean;
}

const Header = styled(Row)`
  min-width: 500px;
`;

export const FilterBox: FC<React.PropsWithChildren<Props>> = ({
  addButtonText,
  hideMatchTypeText = false,
  showFilterType = true,
  fields,
  filter,
  onChange,
  getSelectEditorComponents,
  getFilterOperationTypeOptions,
  getOperationOptionRenderer,
  userOptionsGetter,
}) => {
  return (
    <FilterBoxWrapper className="filter-box">
      <Header>
        <CombinerTypeSelect
          value={filter.type}
          visible={showFilterType}
          onChange={(type) => onChange({ ...filter, type })}
        />
      </Header>
      <GroupedFilter
        addButtonText={addButtonText}
        hideMatchTypeText={hideMatchTypeText}
        fields={fields}
        filter={filter}
        onChange={onChange}
        getFilterOperationTypeOptions={getFilterOperationTypeOptions}
        getSelectEditorComponents={getSelectEditorComponents}
        getOperationOptionRenderer={getOperationOptionRenderer}
        userOptionsGetter={userOptionsGetter}
      />
    </FilterBoxWrapper>
  );
};
